"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectStateReducers = void 0;
var downshift_1 = require("downshift");
var useSelectStateReducers = function (args) {
    var _a = args.callAddSelectedItem, callAddSelectedItem = _a === void 0 ? function () {
        return;
    } : _a, _b = args.callCloseMenu, callCloseMenu = _b === void 0 ? function () {
        return;
    } : _b, _c = args.callOpenMenu, callOpenMenu = _c === void 0 ? function () {
        return;
    } : _c, _d = args.callSelectItem, callSelectItem = _d === void 0 ? function () {
        return;
    } : _d, isMultiSelect = args.isMultiSelect, itemIsDisabled = args.itemIsDisabled, renderItemToString = args.renderItemToString, _e = args.selectInput, selectInput = _e === void 0 ? { current: null } : _e, updateFilteredItems = args.updateFilteredItems;
    var safeItemIsDisabled = itemIsDisabled || (function () { return false; });
    // State reducer for the MultiSelect component
    var multipleSelectionStateReducer = function (_state, actionAndChanges) {
        var type = actionAndChanges.type, changes = actionAndChanges.changes;
        switch (type) {
            case downshift_1.useMultipleSelection.stateChangeTypes.SelectedItemKeyDownBackspace:
            case downshift_1.useMultipleSelection.stateChangeTypes.SelectedItemKeyDownDelete:
            case downshift_1.useMultipleSelection.stateChangeTypes.DropdownKeyDownBackspace:
                updateFilteredItems('', changes.selectedItems);
                return __assign(__assign({}, changes), { activeIndex: -1 });
            case downshift_1.useMultipleSelection.stateChangeTypes.FunctionAddSelectedItem:
            case downshift_1.useMultipleSelection.stateChangeTypes.FunctionRemoveSelectedItem:
            case downshift_1.useMultipleSelection.stateChangeTypes.FunctionSetSelectedItems:
                updateFilteredItems('', changes.selectedItems);
                return changes;
            default:
                return changes;
        }
    };
    var selectInputEvent = function (selectInputEl, event) {
        var selectInputCurrent = selectInputEl.current;
        if (selectInputCurrent) {
            switch (event) {
                case 'blur':
                    selectInputCurrent.blur();
                    break;
                case 'focus':
                    selectInputCurrent.focus();
                    break;
                default:
                    break;
            }
        }
    };
    var singleSelectReducer = function (state, type, changes) {
        switch (type) {
            case downshift_1.useCombobox.stateChangeTypes.InputKeyDownArrowUp:
            case downshift_1.useCombobox.stateChangeTypes.InputKeyDownArrowDown:
                if (!state.isOpen) {
                    updateFilteredItems('');
                    return __assign(__assign({}, changes), { highlightedIndex: 0, inputValue: '' });
                }
                return changes;
            case downshift_1.useCombobox.stateChangeTypes.InputKeyDownEnter:
                return __assign(__assign({}, changes), { inputValue: safeItemIsDisabled(changes.selectedItem) ? '' : renderItemToString(changes.selectedItem), selectedItem: safeItemIsDisabled(changes.selectedItem) ? null : changes.selectedItem, highlightedIndex: 0 });
            case downshift_1.useCombobox.stateChangeTypes.ItemClick:
                callCloseMenu();
                updateFilteredItems('', changes.selectedItem);
                return changes;
            case downshift_1.useCombobox.stateChangeTypes.InputKeyDownEscape:
            case downshift_1.useCombobox.stateChangeTypes.ToggleButtonClick:
                selectInputEvent(selectInput, 'blur');
                updateFilteredItems('');
                return __assign(__assign({}, changes), { inputValue: renderItemToString(changes.selectedItem) });
            case downshift_1.useCombobox.stateChangeTypes.FunctionOpenMenu:
                selectInputEvent(selectInput, 'focus');
                updateFilteredItems('', changes.selectedItem);
                return __assign(__assign({}, changes), { highlightedIndex: 0, inputValue: '' });
            case downshift_1.useCombobox.stateChangeTypes.FunctionCloseMenu:
                selectInputEvent(selectInput, 'blur');
                updateFilteredItems('', changes.selectedItem);
                return __assign(__assign({}, changes), { inputValue: renderItemToString(changes.selectedItem) });
            case downshift_1.useCombobox.stateChangeTypes.FunctionSelectItem:
                updateFilteredItems('', changes.selectedItem);
                if (state.isOpen && !changes.inputValue) {
                    callCloseMenu();
                }
                return __assign(__assign({}, changes), { inputValue: renderItemToString(changes.selectedItem) });
            case downshift_1.useCombobox.stateChangeTypes.InputFocus:
                updateFilteredItems('');
                return __assign(__assign({}, changes), { highlightedIndex: 0, inputValue: '' });
            case downshift_1.useCombobox.stateChangeTypes.InputBlur:
                return __assign(__assign({}, changes), { highlightedIndex: 0, inputValue: renderItemToString(state.selectedItem), selectedItem: state.selectedItem });
            case downshift_1.useCombobox.stateChangeTypes.InputChange:
                updateFilteredItems(changes.inputValue);
                return state.selectedItem ? changes : __assign(__assign({}, changes), { highlightedIndex: 0 });
            default:
                return changes;
        }
    };
    var multiSelectReducer = function (state, type, changes) {
        switch (type) {
            case downshift_1.useCombobox.stateChangeTypes.InputKeyDownArrowUp:
            case downshift_1.useCombobox.stateChangeTypes.InputKeyDownArrowDown:
                if (!state.isOpen) {
                    return __assign(__assign({}, changes), { inputValue: '', selectedItem: null });
                }
                return changes;
            case downshift_1.useCombobox.stateChangeTypes.InputKeyDownEnter:
            case downshift_1.useCombobox.stateChangeTypes.ItemClick:
                if (changes.selectedItem && !safeItemIsDisabled(changes.selectedItem)) {
                    callAddSelectedItem(changes.selectedItem);
                    callSelectItem(null);
                }
                return __assign(__assign({}, changes), { inputValue: '', selectedItem: null });
            case downshift_1.useCombobox.stateChangeTypes.InputKeyDownEscape:
            case downshift_1.useCombobox.stateChangeTypes.ToggleButtonClick:
            case downshift_1.useCombobox.stateChangeTypes.FunctionCloseMenu:
                selectInputEvent(selectInput, 'blur');
                return __assign(__assign({}, changes), { inputValue: '', selectedItem: null });
            case downshift_1.useCombobox.stateChangeTypes.FunctionOpenMenu:
                selectInputEvent(selectInput, 'focus');
                return __assign(__assign({}, changes), { inputValue: '', selectedItem: null });
            case downshift_1.useCombobox.stateChangeTypes.FunctionSelectItem:
                if (changes.selectedItem) {
                    callAddSelectedItem(changes.selectedItem);
                }
                if (!changes.isOpen) {
                    callOpenMenu();
                }
                return __assign(__assign({}, changes), { inputValue: '', selectedItem: null });
            case downshift_1.useCombobox.stateChangeTypes.InputFocus:
                updateFilteredItems(changes.inputValue);
                return __assign(__assign({}, changes), { inputValue: '', selectedItem: null });
            case downshift_1.useCombobox.stateChangeTypes.InputBlur:
                updateFilteredItems(changes.inputValue);
                return __assign(__assign({}, changes), { inputValue: '' });
            case downshift_1.useCombobox.stateChangeTypes.InputChange:
                updateFilteredItems(changes.inputValue);
                return changes.inputValue === '' ? changes : __assign(__assign({}, changes), { highlightedIndex: 0 });
            default:
                return changes;
        }
    };
    // State reducer for the SingleSelect and MultiSelect combobox
    var comboboxStateReducer = function (state, actionAndChanges) {
        var type = actionAndChanges.type, changes = actionAndChanges.changes;
        if (isMultiSelect) {
            return multiSelectReducer(state, type, changes);
        }
        else {
            return singleSelectReducer(state, type, changes);
        }
    };
    return {
        comboboxStateReducer: comboboxStateReducer,
        multipleSelectionStateReducer: multipleSelectionStateReducer,
    };
};
exports.useSelectStateReducers = useSelectStateReducers;
